/* smart-answer-card-body-streaming.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./smart-answer-card-body-streaming.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { Fragment, Suspense, useCallback, useRef } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { cx } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { SmartCardProvider } from '@atlaskit/link-provider';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import { getSAINLayerFrontendMutiArmExperiment } from '../../common/utils/get-sain-layer-frontend-experiment';
import { QueryIntent } from '../../constants';
import { isHello } from '../../utils';
import { useContentTruncationDetector } from '../common/hooks/use-content-truncation-detector';
import { useDelayedResizeObserver } from '../common/hooks/use-delayed-resize-observer';
import { AICollapse } from '../common/ui/ai-collapse';
import { AIDisclaimerAndFeedback } from '../common/ui/ai-disclaimer-and-feedback';
import { AITabs } from '../common/ui/ai-tabs';
import { AITabsHeader } from '../common/ui/ai-tabs-header';
import { AITabsPanel } from '../common/ui/ai-tabs-panel';
import { ReactRenderer } from '../common/ui/react-renderer';
import { ReadMoreButton } from '../common/ui/read-more-button';
import { messages } from './messages';
var styles = {
  root: "_1tkebn52",
  explicitQuestion: "_1tke1edt",
  fullHeight: "_4t3i1osq",
  disclaimer: "_n3tdutpp _19bvpxbi _u5f3pxbi _ca0q1b66"
};
export var SmartAnswerCardBodyStreaming = /*#__PURE__*/React.memo(function SmartAnswerCardBodyStreaming(_ref) {
  var cloudId = _ref.cloudId,
    collapsed = _ref.collapsed,
    onExpandCollapseButtonClick = _ref.onExpandCollapseButtonClick,
    onVisibleTextComplete = _ref.onVisibleTextComplete,
    streamedTextToDisplay = _ref.streamedTextToDisplay,
    queryIntent = _ref.queryIntent;
  var resizeObserverTargetContainerRef = useRef(null);
  var resizeObserverTargetRef = useRef(null);
  var isVisibleTextCompleteRef = useRef(false);
  var onHello = isHello(cloudId);

  // Detect if content is truncated when collapsed
  var isContentTruncated = useContentTruncationDetector(resizeObserverTargetRef, resizeObserverTargetContainerRef, collapsed);
  var showReadMoreButton = collapsed && isContentTruncated;
  var _getSAINLayerFrontend = getSAINLayerFrontendMutiArmExperiment({
      abTestId: 'kd_sain_sources_redesign_pt_2'
    }),
    cohortSourcesRedesignExperimentPt2 = _getSAINLayerFrontend.cohort;
  var resizeObserverCallback = useCallback(function () {
    if (!isVisibleTextCompleteRef.current && resizeObserverTargetRef.current && resizeObserverTargetContainerRef.current) {
      var resizeObserverTargetRefHeight = resizeObserverTargetRef.current.getBoundingClientRect().height;
      var resizeObserverTargetContainerRefHeight = resizeObserverTargetContainerRef.current.getBoundingClientRect().height;
      var isVisibleTextComplete = resizeObserverTargetRefHeight > resizeObserverTargetContainerRefHeight;
      if (isVisibleTextComplete) {
        onVisibleTextComplete();
        isVisibleTextCompleteRef.current = true;
      }
    }
  }, [onVisibleTextComplete]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useDelayedResizeObserver(resizeObserverTargetRef, resizeObserverCallback);
  return /*#__PURE__*/React.createElement(Stack, {
    alignBlock: "stretch",
    grow: "fill",
    spread: "space-between",
    xcss: cx(styles.root, queryIntent === QueryIntent.EXPLICIT_QUESTION && styles.explicitQuestion)
  }, /*#__PURE__*/React.createElement(Stack, {
    alignBlock: "stretch",
    grow: "fill",
    spread: "space-between",
    xcss: styles.fullHeight
  }, /*#__PURE__*/React.createElement(Box, null, onHello || cohortSourcesRedesignExperimentPt2 === 'sources_under_answer' ? /*#__PURE__*/React.createElement(AICollapse, {
    title: /*#__PURE__*/React.createElement(Heading, {
      as: "h2",
      size: "xxsmall"
    }, /*#__PURE__*/React.createElement(Text, {
      color: "color.text.subtlest",
      size: "small",
      weight: "bold"
    }, /*#__PURE__*/React.createElement(FormattedMessage, messages.smart_answer_card_title))),
    isCollapsed: collapsed,
    onExpandCollapse: onExpandCollapseButtonClick,
    ref: resizeObserverTargetContainerRef,
    showReadMoreButton: showReadMoreButton,
    queryIntent: queryIntent
  }, /*#__PURE__*/React.createElement(Box, {
    ref: resizeObserverTargetRef,
    testId: "sain-fmp-target"
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, /*#__PURE__*/React.createElement(SmartCardProvider, null, /*#__PURE__*/React.createElement(ReactRenderer, {
    markdown: streamedTextToDisplay
  }))))) : /*#__PURE__*/React.createElement(AITabs, null, /*#__PURE__*/React.createElement(AITabsHeader, {
    showSourcesTab: false,
    collapsed: collapsed,
    onExpandCollapseButtonClick: onExpandCollapseButtonClick
  }), /*#__PURE__*/React.createElement(AITabsPanel, {
    collapsed: collapsed,
    ref: resizeObserverTargetContainerRef,
    showReadMoreButton: showReadMoreButton,
    queryIntent: queryIntent
  }, /*#__PURE__*/React.createElement(Box, {
    ref: resizeObserverTargetRef,
    testId: "sain-fmp-target"
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, /*#__PURE__*/React.createElement(SmartCardProvider, null, /*#__PURE__*/React.createElement(ReactRenderer, {
    markdown: streamedTextToDisplay
  })))))), showReadMoreButton && /*#__PURE__*/React.createElement(ReadMoreButton, {
    onClick: onExpandCollapseButtonClick
  })), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.disclaimer
  }, /*#__PURE__*/React.createElement(AIDisclaimerAndFeedback, {
    showFeedbackButtons: false
  }))));
}, function (prevProps, nextProps) {
  return prevProps.collapsed === nextProps.collapsed && prevProps.streamedTextToDisplay === nextProps.streamedTextToDisplay;
});